import { FC } from "react";
import { GradientButton, PhoneFrame } from "./components";
import { useLocation, useNavigate } from "react-router-dom";

import InvoicingSendAlertSVG from "../../assets/InvoicingSendAlertSVG.svg";

export const InvoicingSendAlert: FC = () => {
	const location = useLocation();
	const { accountType } = location.state;

	const navigate = useNavigate();

	return (
		<div className="w-full h-screen flex justify-center items-center gap-20 background max-2xl:gap-0">
			<PhoneFrame
				onPress={() =>
					navigate("/create-account-wallet/send-ccmei", {
						state: { accountType },
					})
				}
			/>

			<div className="bg-[#7C7775]/80 max-w-[50%] rounded-2xl p-[4%] border-2 border-black">
				<div className="w-full flex flex-col items-center justify-center">
					<p className="font-bold text-white text-4xl text-center max-2xl:text-xl">
						Precisamos de uma <br />
						última informação.
					</p>

					<p className="font-extralight text-white text-xl text-center mt-4 mb-8 max-2xl:text-base max-2xl:mb-2">
						Para segurança do seu cadastro, será <br />
						necessário que você anexe no cadastro o PDF <br />
						do faturamento mensal da sua empresa.
					</p>

					<img
						className="mb-8 ml-5 w-[60%] max-2xl:w-[40%] max-2xl:mb-2"
						src={InvoicingSendAlertSVG}
						alt=""
					/>

					<div className="flex gap-4 mt-16">
						<GradientButton
							title="Voltar"
							tailwindStyles="bg-[#171717] w-[8rem] xl:w-[16rem] h-12 lg:h-16 text-white p-texte"
							onClick={() =>
								navigate("/create-account-wallet/send-ccmei", {
									state: { accountType },
								})
							}
						/>
						<GradientButton
							title="Avançar"
							tailwindStyles="bg-[#AA7339] w-[8rem] xl:w-[16rem] h-12 lg:h-16 text-white p-texte"
							onClick={() =>
								navigate("/create-account-wallet/send-invoicing-pdf", {
									state: { accountType },
								})
							}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
